export default {"src":"/_next/static/media/uncompromising-privacy.68948099.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};